import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {t} from '@github-ui/swp-core/lib/utils/localization'
import {Image, LogoSuite} from '@primer/react-brand/esm'

// IDE Icons
import EclipseIcon from '../../_assets/ide-icons/eclipse.svg'
import GitHubIcon from '../../_assets/ide-icons/github.svg'
import JetBrainsIcon from '../../_assets/ide-icons/jetbrains-logo.svg'
import NeovimIcon from '../../_assets/ide-icons/neovim.svg'
import RaycastIcon from '../../_assets/ide-icons/raycast-logo.svg'
import SqlServerManagementStudioIcon from '../../_assets/ide-icons/sql-server-management-studio-logo.svg'
import VisualStudioIcon from '../../_assets/ide-icons/visualstudio.webp'
import VSCodeIcon from '../../_assets/ide-icons/vscode.svg'
import XcodeIcon from '../../_assets/ide-icons/xcode.svg'
import ZedIcon from '../../_assets/ide-icons/zed.svg'

// App Icons
import SlackIcon from '../../_assets/app-icons/slack.svg'
import TeamsIcon from '../../_assets/app-icons/teams.svg'

import styles from './CopilotLogoSuite.module.css'

const logoSuiteItems = [
  {
    name: 'GitHub',
    href: 'https://github.com/copilot',
    image: GitHubIcon,
    action: 'github',
  },
  {
    name: 'VS Code',
    href: 'https://marketplace.visualstudio.com/items?itemName=GitHub.copilot-chat',
    image: VSCodeIcon,
    action: 'vscode',
  },
  {
    name: 'Visual Studio',
    href: 'https://visualstudio.microsoft.com/github-copilot',
    image: VisualStudioIcon,
    action: 'vs',
  },
  {
    name: 'Xcode',
    href: 'https://github.com/github/CopilotForXcode',
    image: XcodeIcon,
    action: 'xcode',
  },
  {
    name: 'Teams',
    href: 'https://teams.microsoft.com/l/app/836ecc9e-6dca-4696-a2e9-15e252cd3f31',
    image: TeamsIcon,
    action: 'teams',
  },
  {
    name: 'Slack',
    href: 'https://github.slack.com/marketplace/A01BP7R4KNY-github',
    image: SlackIcon,
    action: 'slack',
  },
  {
    name: 'JetBrains IDEs',
    href: 'https://plugins.jetbrains.com/plugin/17718-github-copilot',
    image: JetBrainsIcon,
    action: 'jetbrains',
  },
  {
    name: 'Neovim',
    href: 'https://github.com/github/copilot.vim',
    image: NeovimIcon,
    action: 'neovim',
  },
  {
    name: 'Eclipse',
    href: 'https://marketplace.eclipse.org/content/github-copilot#details',
    image: EclipseIcon,
    action: 'eclipse',
  },
  {
    name: 'Raycast',
    href: 'https://gh.io/copilot-raycast-docs',
    image: RaycastIcon,
    action: 'raycast',
  },
  {
    name: 'SQL Server Management Studio',
    href: 'https://learn.microsoft.com/ssms/github-copilot/get-started',
    image: SqlServerManagementStudioIcon,
    action: 'sqlservermanagementstudio',
  },
  {
    name: 'Zed',
    href: 'https://zed.dev/acp/agent/github-copilot',
    image: ZedIcon,
    action: 'zed',
  },
  // {
  //   name: 'Chrome',
  //   href: 'https://chromewebstore.google.com/detail/github-copilot/hblomdgalaelcilcdepgohfcogjiijhe',
  //   image: ChromeIcon,
  //   action: 'chrome',
  // },
]

type Props = {
  location: string
  heading?: string
}

export function CopilotLogoSuite({location, heading}: Props) {
  return (
    <LogoSuite className={styles.CopilotLogoSuite} align="center" hasDivider={false}>
      <LogoSuite.Heading>{heading ?? t('Copilot integrations')}</LogoSuite.Heading>
      <LogoSuite.Logobar marquee marqueeSpeed="slow">
        {logoSuiteItems.map(({name, href, image, action}) => (
          <a
            key={action}
            href={href}
            {...getAnalyticsEvent({
              action,
              tag: 'icon',
              context: 'editors',
              location,
            })}
          >
            <Image src={`${image}?v=1`} alt={name} width="40" height="40" loading="lazy" />
          </a>
        ))}
      </LogoSuite.Logobar>
    </LogoSuite>
  )
}
